// extracted by mini-css-extract-plugin
export default {"system_check_wrap":"SystemCheckInfo_system_check_wrap__-hw8j","box":"SystemCheckInfo_box__grb8G","today_close":"SystemCheckInfo_today_close__0CVtA"};